import { MAP_LAYER } from 'components/Map/constants';

// Custom feature property carrying the raw zone rate. Useful for debugging
// and for any downstream consumer that needs the underlying value alongside
// the fill styling; not driven off by the paint expression.
export const PRESCRIPTION_RATE_PROPERTY = 'rate';

// Custom feature property carrying the rate normalized into [0, 1] against
// the current ApiRateBounds. The paint expression registered in
// useLayerStyles interpolates fill-color off of this — keeping the paint
// expression bounds-agnostic and removing the need for a runtime
// setPaintProperty call when bounds change.
export const PRESCRIPTION_NORMALIZED_RATE_PROPERTY = 'normalizedRate';

// Re-exported so the hook doesn't need to reach into components/Map/constants
// directly at use sites.
export { MAP_LAYER };
